module.exports = __webpack_public_path__ + "img/2021_0403_From-Ray.82debb17.jpg";